export default __webpack_public_path__ + "static/media/top-part.dc2f1a61.png";